import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FilterParams } from '../models/filter-params';
import { Environment } from '@t-llevo/util';

@Injectable()
export class ReportExcelService {
  constructor(
    @Inject(Environment) public env: Environment,
    public http: HttpClient
  ) {}

  getReportExcel(url: string, filters: FilterParams): Observable<Blob> {
    const params = { ...filters, format: 'xlsx' };
    const headers = new HttpHeaders({
      Accept:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8',
    });
    return this.http.get<Blob>(`${this.env.apiUrl}${url}`, {
      params,
      headers,
      responseType: 'blob' as 'json',
    });
  }

  downloadFile(data: Blob, fileName: string, type: string, elem: HTMLElement) {
    const blob = new Blob([data], { type });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.style.display = 'none';
    link.download = fileName;
    link.innerHTML = fileName;
    elem.appendChild(link);
    link.click();
    elem.removeChild(link);
    URL.revokeObjectURL(url);
  }
}
